import { IFormViewForm } from 'components/FormView';

const SaleConfirmation: IFormViewForm = {
    id: 'SaleConfirmationForm',
    layout: {
        rows: 1,
        columns: 1,
    },
    fields: [
        {
            id: '1',
            type: 'PAPER_CONTAINER',
            visible: true,
            props: {
                name: 'activity',
                fullWidth: true,
                elevation: 0
            },
            position: {
                row: 1,
                col: 1,
                colspan: 3

            },
            children: [
                {
                    id: 1,
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    props: {
                        name: 'InvoiceSale',
                        defaultValue: false,
                        label: 'Invoice this sale',
                    }
                },
                {
                    id: 2,
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '30%',
                    },
                    props: {
                        name: 'OutputInvoice',
                        defaultValue: false,
                        label: 'Invoice',
                        style: {
                            width: 'fit-content',
                            marginLeft: '10px'
                        }
                    }
                },
                {
                    id: 3,
                    type: 'DOCUMENT_OUTPUT_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '70%',
                    },
                    props: {
                        size: 'large',
                        label: 'Print to printer',
                        name: 'InvoiceOutput',
                        fieldId: 'InvoiceOutput',
                        documentType: 'SO',
                        isCustomerSupplierScoped: true,
                        precedentFields: ['OutputInvoice'],
                    }
                },
                {
                    id: 4,
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '30%',
                    },
                    props: {
                        name: 'OutputSalesDocket',
                        defaultValue: false,
                        label: 'Sales docket',
                        precedentFields: ['InvoiceSale'],
                        style: {
                            marginLeft: '10px',
                            width: 'fit-content'
                        }
                    }
                },
                {
                    id: 5,
                    type: 'DOCUMENT_OUTPUT_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '70%',
                    },
                    props: {
                        size: 'large',
                        label: 'Print to printer',
                        name: 'SalesDocketOutput',
                        fieldId: 'SalesDocketOutput',
                        documentType: 'SO',
                        isCustomerSupplierScoped: true,
                        precedentFields: ['OutputSalesDocket'],
                    }
                },
                {
                    id: 6,
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '26%',
                        marginLeft: '4%',
                        verticalAlign: 'sub'
                    },
                    props: {
                        name: 'OutputBarcodeLabel',
                        defaultValue: false,
                        label: 'Barcode label',
                    }
                },
                {
                    id: 7,
                    type: 'DOCUMENT_OUTPUT_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '70%',
                    },
                    props: {
                        size: 'large',
                        label: 'Print to printer',
                        name: 'BarcodeLabelOutput',
                        fieldId: 'BarcodeLabelOutput',
                        documentType: 'SO',
                        isCustomerSupplierScoped: true,
                        precedentFields: ['OutputBarcodeLabel'],
                    }
                },
                {
                    id: 8,
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '30%',
                    },
                    props: {
                        name: 'OutputPickSlip',
                        defaultValue: false,
                        label: 'Pick slip',
                    }
                },
                {
                    id: 9,
                    type: 'DOCUMENT_OUTPUT_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '70%',
                    },
                    props: {
                        size: 'large',
                        label: 'Print to printer',
                        name: 'PickSlipOutput',
                        fieldId: 'PickSlipOutput',
                        documentType: 'SO',
                        isCustomerSupplierScoped: true,
                        bypassInternalDocumentToggle: true,
                        precedentFields: ['OutputPickSlip'],
                    }
                },
                {
                    id: 10,
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '30%',
                    },
                    props: {
                        name: 'OutputAcknowledgement',
                        defaultValue: false,
                        label: 'Order ack',
                    }
                },
                {
                    id: 11,
                    type: 'DOCUMENT_OUTPUT_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '70%',
                    },
                    props: {
                        size: 'large',
                        label: 'Print to printer',
                        name: 'OrderAcknowledgementOutput',
                        fieldId: 'OrderAcknowledgementOutput',
                        documentType: 'SO',
                        isCustomerSupplierScoped: true,
                        precedentFields: ['OutputAcknowledgement'],
                    }
                },
                {
                    id: 12,
                    type: 'DIVIDER',
                    props: {
                    }
                },
                {
                    id: 13,
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'Order category',
                        name: 'SalesOrderCategory',
                        lookupName: 'OrderCategory',
                        isLookupTypeFixed: true,
                        size: 'small',
                    }
                },
                {
                    id: 14,
                    type: 'EX_LOOKUP_FIELD',
                    visible: true,
                    props: {
                        label: 'Sales rep',
                        name: 'SalesRepresentative',
                        lookupName: 'SalesRep',
                        placeholder: '',
                        size: 'small',

                    }
                },
                {
                    id: 15,
                    type: 'TEXT_FIELD',
                    style: {
                        width: '50%'
                    },
                    props: {
                        label: 'Customer purchase order',
                        name: 'CustomerPurchaseOrder',
                        placeholder: '',
                        size: 'large',
                        required: false
                    }
                },
                {
                    id: 16,
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'User ID',
                        name: 'WorksaleUserId',
                        size: 'small',
                        lookupName: 'Personnel',
                        isLookupTypeFixed: true,
                        required: true,
                    }
                },
                {
                    id: 17,
                    type: 'TEXT_FIELD',
                    props: {
                        label: 'PIN',
                        name: 'WorksaleUserPin',
                        placeholder: '****',
                        size: 'small',
                        type: 'password',
                        inputProps: {
                            maxLength: 4
                        },
                        required: false
                    }
                },
            ]
        }
    ]
};

export default SaleConfirmation;
